// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#Summary .appbar-info-general img{width:100%}#Summary .chip-general-info .avatar,#Summary .chip-header .avatar{background-color:#fff;border:1.5px solid var(--primary);height:37px;width:37px}#Summary .chip-header .avatar i{font-size:18px;margin-right:-1px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
